import { BaseModel } from './BaseModel';
import RedeemCode from './RedeemCode';

export class Redeem extends BaseModel {
  static get entity() {
    return 'redeems';
  }

  static get fk() {
    return 'redeem_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      redeem_code_id: this.attr(null),
      redeem_code: this.belongsTo(RedeemCode, 'redeem_code_id'),
      user: this.attr(null),
      redeemed_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      find(params = {}) {
        return this.get('/redeems', { params });
      }
    }
  };
}

export default Redeem;
